import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { LocaleService } from '@next/core-lib/i18n';
import { NavigationActions, ParentNavigationItem } from '@next/core-lib/navigation';
import { WrapperSiteSidenavComponent } from '@next/core-lib/wrapper-site-sidenav';
import { Store } from '@ngrx/store';

import { Environment } from '../environment';
import { SiteState } from './shared/models';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [WrapperSiteSidenavComponent, RouterOutlet],
})
export class AppComponent implements OnInit {
  private readonly store = inject<Store<SiteState>>(Store);
  private readonly locale = inject(LocaleService);
  private readonly env = inject<Environment>(EnvironmentInjector);

  readonly navigationItems: ParentNavigationItem[] = [
    {
      label: 'app.home.module',
      iconKey: 'home-dashboard',
      relativeUrl: '/home',
    },
    {
      label: 'app.economy.module',
      icon: 'euro',
      relativeUrl: '/economy',
    },
    {
      label: 'app.sustainability.module',
      icon: 'eco',
      children: [
        {
          label: 'sustainability.sustainability.menu-item',
          relativeUrl: '/sustainability',
        },
        {
          label: 'sustainability.co2-deliveries.menu-item',
          relativeUrl: '/co2-deliveries',
        },
        {
          label: 'sustainability.co2-example-company.menu-item',
          relativeUrl: '/co2-example-company',
        },
      ],
    },
    {
      label: 'app.feed.module',
      iconKey: 'lab_profile',
      children: [
        {
          label: 'feed.rations.menu-item',
          relativeUrl: '/rations',
        },
        {
          label: 'feed.silage-results.menu-item',
          relativeUrl: '/silage-results',
        },
        {
          label: 'feed.lab-results.menu-item',
          absoluteUrl: this.env.LABRESULT_URL,
        },
        {
          label: 'feed.deliveries.menu-item',
          relativeUrl: '/deliveries',
        },
      ],
    },
    {
      label: 'app.dairyresults.module',
      iconKey: 'lab_profile',
      children: [
        {
          label: 'dairyresults.dairy-overview.menu-item',
          relativeUrl: '/overview',
        },
        {
          label: 'dairyresults.production.menu-item',
          relativeUrl: '/production',
        },
        {
          label: 'dairyresults.individual-production.menu-item',
          relativeUrl: '/individual-production',
        },
        {
          label: 'dairyresults.milk-delivery.menu-item',
          relativeUrl: '/milk-delivery',
        },
        {
          label: 'dairyresults.milk-delivery-month-summary.menu-item',
          relativeUrl: '/month-summary',
        },
      ],
    },
    {
      label: 'app.fertility.module',
      iconKey: 'lab_profile',
      children: [
        {
          label: 'fertility.fertility-summary.menu-item',
          relativeUrl: '/fertility-summary',
        },
        {
          label: 'fertility.individual-fertility.menu-item',
          relativeUrl: '/individual-fertility',
        },
      ],
    },
    {
      label: 'app.health.module',
      iconKey: 'lab_profile',
      children: [
        {
          label: 'health.health-summary.menu-item',
          relativeUrl: '/health-summary',
        },
        {
          label: 'health.individual-health.menu-item',
          relativeUrl: '/individual-health',
        },
      ],
    },
  ];

  direction$ = this.locale.direction$;

  ngOnInit(): void {
    this.store.dispatch(
      NavigationActions.setNavigationItems({
        navigationItems: this.navigationItems,
      }),
    );
  }
}
